module.exports = __webpack_public_path__ + "static/media/enrollment_warning_2.53ce7f1e.svg";